import { render, staticRenderFns } from "./editMap.vue?vue&type=template&id=3623d772&scoped=true"
import script from "./editMap.vue?vue&type=script&lang=js"
export * from "./editMap.vue?vue&type=script&lang=js"
import style0 from "./editMap.vue?vue&type=style&index=0&id=3623d772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3623d772",
  null
  
)

export default component.exports